module.exports = __webpack_public_path__ + "img/4d902.f6d0496f.svg";